<template>
  <div class="animated fadeIn">
    <b-card-body class="m-0 pt-0" id="areaImprimir">
      <div class="text-center">
        <b-spinner v-if="!process" label="Spinning"></b-spinner>
      </div>
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <h1 class="text-right">
            INFORME DE PROCESO #{{ process[0].process.number }}
          </h1>
          <p class="text-right">
            {{ process[0].process.process_date | moment }}
          </p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"
            ><i class="fa fa-download"></i
          ></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col sm="3">
          <h6 class="mb-3">Procesado en:</h6>
          <div>
            <strong>{{ process[0].process.plant.name }}</strong>
          </div>
          <div>CSP: {{ process[0].process.plant.plant_code }}</div>
          <div>{{ process[0].process.plant.company.address1 }}</div>
          <div>Email: {{ process[0].process.plant.company.email }}</div>
          <div>Telefono: {{ process[0].process.plant.company.phone }}</div>
        </b-col>

        <b-col sm="3">
          <h6 class="mb-3">Solicitud:</h6>
          <div>
            <strong>{{
              process[0].process.client_customer.company_name
            }}</strong>
          </div>
          <div>
            Huerto: {{ process[0].content.origin_name }} ({{
              process[0].content.origin_code
            }})
          </div>
          <div>Producto: {{ process[0].content.product_name }}</div>
          <div>Variedad: {{ process[0].content.variety_name }}</div>
          <div>Condicion: {{ process[0].content.condition }}</div>
        </b-col>

        <b-col sm="3">
          <h6 class="mb-3">Detalles:</h6>
          <div>Tipo de proceso: {{ process[0].process.process_type.name }}</div>
          <div>
            Línea de proceso: {{ process[0].process.process_room.name }}
          </div>
          <div>
            Jefe de proceso:
            {{ process[0].process.shift_supervisor.first_name }}
            {{ process[0].process.shift_supervisor.last_name }}
          </div>
          <div>
            Fecha de proceso: {{ process[0].process.process_date | moment }}
          </div>
          <div>Turno: {{ process[0].process.shift.name }}</div>
        </b-col>
      </b-row>
      <h6 class="mb-2 font-weight-bold">Movimientos:</h6>
      <div class="table-responsive-sm">
        <table class="table  table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th class="text-center align-middle">Pallet Origen</th>
              <th class="text-center">Cantidad</th>
              <th class="text-center align-middle">Pallet Destino</th>
              <th class="text-center align-middle">Formato</th>
              <th class="text-center align-middle">Variedad</th>
              <th class="text-center align-middle">Huerto</th>
              <th class="text-center align-middle">Fecha embajale</th>
              <th class="text-center align-middle">Planta</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(content, index) in tableDataMovimientos">
              <td class="text-center align-middle">{{ index + 1 }}</td>
              <td class="text-center align-middle">
                {{ content.Pallet_salida }}
              </td>
              <td class="text-center align-middle">{{ content.Cantidad }}</td>
              <td class="text-center align-middle">
                {{ content.Pallet_entrada }}
              </td>
              <td class="text-center align-middle">{{ content.container }}</td>
              <td class="text-center align-middle">{{ content.variety }}</td>
              <td class="text-center align-middle">{{ content.origin }}</td>
              <td class="text-center align-middle">
                {{ content.creation_date | moment }}
              </td>
              <td class="text-center align-middle">
                {{ content.plant == null ? "" : content.plant.name }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="text-center"></td>
              <td class="text-center">TOTALES</td>
              <td class="text-center">{{ totalQuantityIn }}</td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="text-right"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <b-row>
        <b-col lg="6">
          <b-card border-variant="white">
            <p>Notas: {{ process[0].process.note }}</p>
          </b-card>
        </b-col>
      </b-row>
      <hr />
      <p class="small text-center">
        El Porcentaje de embalaje corresponde a la suma de los kilos netos de
        exportación, más los kilos netos de deshidratación, y se considera como
        el rendimiento efectivo de la fruta.
      </p>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";

export default {
  name: "ImprimirRepaletizaje",
  created() {},
  props: ["process", "tableDataMovimientos"],
  data() {
    return {
      img: "",
      client: null
    };
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD-MM-YYYY");
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
    this.client = this.$store.getters.user.ID_CLIENTE;
  },
  methods: {
    descargarPDF: function() {
      var element = document.getElementById("areaImprimir").innerHTML;

      var opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.99 },
        html2canvas: { scale: 2, dpi: 192, letterRendering: true },
        filename: "Informe Proceso #" + this.process[0].process.number + ".pdf",
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
      };
      html2pdf()
        .from(element)
        .set(opt)
        .save();
    }
  },
  computed: {
    totalQuantityIn() {
      return this.tableDataMovimientos.reduce(
        (total, item) => total + item.Cantidad,
        0
      );
    }
  },
  beforeMount() {}
};
</script>

<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.15rem;
}
</style>
